import { EditorCanvasComponent } from '../../editor-canvas/editor-canvas.component';
import { Command } from './command.model';
import { EditorObject } from '../editor-object.model';
import * as _ from "underscore";

export class AddCommand implements Command {
    editorObj: EditorObject;
    constructor(eo: EditorObject, x: number, y: number) {
        this.editorObj = eo.copy();
        this.editorObj.x(x);
        this.editorObj.y(y);
        this.editorObj.setAbsolutePosition({ x: x, y: y });
    }

    execute(editorCanvas: EditorCanvasComponent): boolean {
        editorCanvas.addNewEditorObject(this.editorObj);
        editorCanvas.stage.batchDraw();
        return true;
    }
}